import { KnownDesktopReport } from 'common/types/reports/desktop'

export const translate = (key: string): string => {
  if (key === KnownDesktopReport.DailyDistribution) {
    return 'Выдано за день'
  }

  if (key === KnownDesktopReport.DailyOrders) {
    return 'Заказано на день'
  }

  if (key === KnownDesktopReport.DailySales) {
    return 'Продано за день'
  }

  if (key === KnownDesktopReport.FundsSales) {
    return 'Продано по видам средств'
  }

  if (key === KnownDesktopReport.PaymentModeSales) {
    return 'Продано по способу расчета'
  }

  if (key === KnownDesktopReport.DayBySaleType) {
    return 'Продано по типу продукции'
  }

  if (key === KnownDesktopReport.DayCash) {
    return 'Продано наличными'
  }

  if (key === 'restrict_print') {
    return 'Запретить печать отчета при наличии не проведенных продаж и заявок'
  }

  return `Неизвестный отчет (${key})`
}
